import React, { useCallback, useState } from 'react'
import { bool, func, string } from 'prop-types'
import Modal from 'react-modal'

import TextareaField from 'Pods/Shared/TextareaField'

function CustomLicenseModal({
  modalIsOpen,
  closeModal,
  onSubmit,
  license,
}) {
  const [customLicense, setCustomLicense] = useState('')

  const handleInputChange = useCallback((e) => {
    setCustomLicense(e.target.value)
  }, [])

  const onModalClose = useCallback(() => {
    setCustomLicense('')
    closeModal()
  }, [closeModal])

  const setCustomLicenseCallback = useCallback(() => {
    onSubmit(customLicense)
    onModalClose()
  }, [customLicense, onSubmit, onModalClose])

  return (
    <Modal
      isOpen={modalIsOpen}
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal overlay-modal--custom-license-modal">
        <TextareaField
          label={license === 'custom_no_ai' ? 'Custom license, no AI' : 'Custom license'}
          id="customLicense"
          name="custom_license"
          required
          rows={5}
          value={customLicense}
          formClassName="form-group-grey"
          inputClassName="form-control-grey"
          onChange={handleInputChange}
        />

        <div className="u-text-right">
          <button className="btn btn-secondary u-mr10" onClick={onModalClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={setCustomLicenseCallback}
            disabled={!customLicense}
          >
            Set custom license
          </button>
        </div>
      </div>
    </Modal>
  )
}

CustomLicenseModal.propTypes = {
  modalIsOpen: bool.isRequired,
  closeModal: func.isRequired,
  onSubmit: func.isRequired,
  license: string.isRequired,
}

export default CustomLicenseModal
